import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Autocomplete,
  Button,
} from "@mui/material";
import { UseFavoritProduct } from "./UseFavoritProduct";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import CheckIcon from "@mui/icons-material/Check";
import StoreFilter from "./StoreFilter";

export default function FavoritProduct(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, updatePage, updateSort } = UseMyPC("FavoritCount", "Desc");
  const { GetFavoritProductReport } = UseFavoritProduct();
  const [reportRes, setReportRes] = useState();
  const [store, setStore] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    setProgress(true);
    GetFavoritProductReport(store, myPc, true, (callback) => {
      setReportRes(callback);
    });
  }, [myPc, store]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      sortable: false,
      headerAlign: "center",
    },
    {
      field: "productID",
      width: 110,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
    },
    {
      field: "productName",
      width: 250,
      align: "left",
      headerName: "نام محصول",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "برند",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "favoritCount",
      headerName: "تعداد",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.favoritCount
              ? toMoney(cellValues.row.favoritCount)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "stock",
      headerName: "موجودی",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.stock ? toMoney(cellValues.row.stock) : 0}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "قیمت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "discountPercent",
      headerName: "درصد تخفیف",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.discountPercent !== 0
              ? cellValues.row.discountPercent + " %"
              : 0}
          </Typography>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        // backButtonDef: {
        //   state: location.state,
        //   replace: true,
        // },
        // backURL: "/ordersreport",
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/favoritproducts" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <StoreFilter store={store} setStore={setStore} />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {reportRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.pageCount
                  : 1
              }
              rows={reportRes ? reportRes.products : []}
              paginationMode="server"
              page={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.page - 1
                  : 1
              }
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    reportRes && reportRes.pageCondition.totalItemCount
                      ? reportRes.pageCondition.totalItemCount
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .Green": {
                  backgroundColor: "#56ff004f !important",
                },
                "& .red": {
                  backgroundColor: "#ff9d9d !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.store) {
                  return "Green";
                } else {
                  return "red";
                }
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
    </Detail>
  );
}
